/**
 * Enables you to refresh table when scrolling
 * @param node
 */
export class TableRefresh {
    #unlisten: (() => void)[] = []
    constructor(node: HTMLElement, onScroll: () => void) {
        node.querySelectorAll(".scrollable-table").forEach((element) => {
            element.addEventListener("scroll", onScroll)
            this.#unlisten.push(() =>
                element.removeEventListener("scroll", onScroll)
            )
        })
    }

    destroy() {
        this.#unlisten.forEach((e) => e())
    }
}
